//get the origin app which is needed for some actions that involve redirecting to central
import packageInfo from '../../../../package.json';

/**
 * When there are flags in the user object, it requires us to act upon them.
 * I am implementing this here and not in Central as event can be also app related
 * and it is going to be easier if the apps will redirect back into central
 * 
 * The flow is: user go to app, if not auth -> goes to central -> if auth -> go to app ->every time the user object 
 * is read, action flags will be checked for and acted upon
 */
//TODO sync from server?
const FLAG_NAME__REQUIREPROFILEUPDATE = 'REQUIREPROFILEUPDATE';

export default function handleUserFlagsEvents(flag){
  switch(flag){
    case FLAG_NAME__REQUIREPROFILEUPDATE:
      window.location.href=`/central${packageInfo.homepage}/user/profile/update`;
      break;

    default:
      //TODO report this error to the server via API
      console.error('Unknown user flag intercepted',flag);
      break;
  }
}


/* test queries

insert into demographics.user_flags(user_id,flag_name, date_created, created_by, system_comments)
values (101017,'REQUIREPROFILEUPDATE',getdate(),2,'baba1')

*/